import Reveal from "@/components/Reveal";
import LeafSignature from "@/components/heritage/LeafSignature";

/**
 * Calm editorial breath between the island gateway and commerce.
 * Pure white background, narrow column, generous whitespace.
 */
const RootedMemoryEditorial = () => {
  return (
    <section className="relative bg-white py-20 sm:py-28 md:py-36 lg:py-44">
      <LeafSignature variant="watermark" position="top-right" size="lg" tone="light" />
      <div className="relative mx-auto px-6 sm:px-8 text-center w-full max-w-[640px]">
        <Reveal>
          <p className="font-sans text-[10px] sm:text-[11px] tracking-[0.42em] uppercase text-accent mb-6 sm:mb-8">
            Sugar Town Organics
          </p>
          <h2 className="font-serif text-[1.75rem] sm:text-3xl md:text-4xl lg:text-[2.5rem] text-foreground leading-[1.2] mb-8 sm:mb-10">
            Rooted memory. Living future.
          </h2>
          <div aria-hidden className="mx-auto mb-8 sm:mb-10 h-px w-12 bg-accent/60" />
          <p className="font-serif italic text-foreground/75 text-base sm:text-lg md:text-xl leading-[1.7] mb-5 sm:mb-6">
            Sugar Town Organics is a Caribbean Legacy House inspired by the
            botanical wisdom, food traditions, and wellness rituals of
            St. Kitts &amp; Nevis.
          </p>
          <p className="font-sans text-sm sm:text-base md:text-lg text-foreground/65 leading-[1.8]">
            We craft beauty, wellness, food, and immersive experiences designed
            to reconnect people to slower living, intentional care, and the
            richness of Caribbean life.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default RootedMemoryEditorial;
